import { handleActions } from "redux-actions";
import { CategoriesI, ModulesI } from "../../typings/routesTypes";

import {
  GET_CATEGORIES,
  GET_MODULES,
  UPDATE_CURRENT_MODULE,
  UPDATE_CURRENT_CATEGORY,
  GET_FILTERED_CATEGORIES,
  UPDATE_FILTERED_CATEGORIES,
  GET_ROUTES,
  UPDATE_SEARCH_MODE,
  SET_AI_FEEDBACK_MODAL_VISIBLE,
  SET_AI_FEEDBACK_FORM_FILLED,
  SUBMIT_AI_FEEDBACK,
  SET_CONTACT_MODAL_VISIBLE,
  SHOW_POLL_POPUP,
  HIDE_POLL_POPUP
} from "./constants";

import { PollPopupI, routeInterface } from "../../typings/interfaces";
import { LocalStorageKey, SearchMode } from "../../models";
import { localStorage } from "../../services";

const SEARCH_MODE_EXPIRY_DAYS = 5;

function getInitialSearchMode(): string {
  const stored = localStorage.getItem(LocalStorageKey.searchMode);

  if (stored && stored.mode && stored.timestamp) {
    const daysSinceLastUse = (Date.now() - stored.timestamp) / (1000 * 60 * 60 * 24);

    if (daysSinceLastUse < SEARCH_MODE_EXPIRY_DAYS) {
      return stored.mode === SearchMode.classic ? SearchMode.classic : SearchMode.ai;
    }
  }

  return SearchMode.ai;
}

interface InitialStateI {
  modules: ModulesI[];
  categories: CategoriesI[];
  currentModule: string;
  currentCategory: string;
  filteredCategories: FilteredCategoriesI[];
  routes: routeInterface[] | [];
  searchMode: string;
  isAIFeedbackModalVisible: boolean;
  isAIFeedbackFormFilled: boolean;
  isContactModalVisible: boolean;
  pollPopup: PollPopupI | null;
}
interface FilteredCategoriesI {
  moduleName: string;
  categories: CategoriesI[];
}

const initialState: InitialStateI = {
  modules: [],
  categories: [],
  currentModule: "",
  currentCategory: "",
  filteredCategories: [],
  routes: [],
  searchMode: getInitialSearchMode(),
  isAIFeedbackModalVisible: false,
  isAIFeedbackFormFilled: false,
  isContactModalVisible: false,
  pollPopup: null
};

function getModules(state: typeof initialState, { payload }) {
  return {
    ...state,
    modules: payload
  };
}

function getCategories(state: typeof initialState, { payload }) {
  return {
    ...state,
    categories: payload
  };
}

function updateCurrentModule(state: typeof initialState, { payload }) {
  return {
    ...state,
    currentModule: payload
  };
}

function updateCurrentCategory(state: typeof initialState, { payload }) {
  return {
    ...state,
    currentCategory: payload
  };
}

function setFilteredCategories(state: typeof initialState, { payload }) {
  const filteredCategories = [];
  const { modules, categories } = state;

  if (Object.keys(payload).length > 0) {
    modules.forEach(m => {
      if (payload[m.name]) {
        filteredCategories.push({
          moduleName: m.displayName,
          categories: categories
            .filter(c => payload[m.name][c.name])
            .map(c => ({
              name: c.name,
              displayName: c.displayName,
              count: payload[m.name][c.name],
              module: m.name
            }))
        });
      }
    });
  }

  return {
    ...state,
    filteredCategories
  };
}

function getRoutes(state: typeof initialState, { payload }) {
  return {
    ...state,
    routes: payload
  };
}

function updateSearchMode(state: typeof initialState, { payload }) {
  return {
    ...state,
    searchMode: payload
  };
}

function setAIFeedbackModalVisible(state: typeof initialState, { payload }) {
  return {
    ...state,
    isAIFeedbackModalVisible: payload
  };
}

function setIsAIFeedbackFormFilled(state: typeof initialState, { payload }) {
  return {
    ...state,
    isAIFeedbackFormFilled: payload
  };
}

function submitAIFeedback(state: typeof initialState, { payload }) {
  if (!payload || !payload.success) {
    return state;
  }

  return {
    ...state,
    isAIFeedbackModalVisible: false,
    isAIFeedbackFormFilled: true
  };
}

export default handleActions(
  {
    [GET_MODULES]: getModules,
    [UPDATE_CURRENT_MODULE]: updateCurrentModule,
    [UPDATE_CURRENT_CATEGORY]: updateCurrentCategory,
    [GET_CATEGORIES]: getCategories,
    [GET_FILTERED_CATEGORIES]: setFilteredCategories,
    [UPDATE_FILTERED_CATEGORIES]: (
      state: typeof initialState,
      { payload }
    ) => ({
      ...state,
      filteredCategories: payload
    }),
    [GET_ROUTES]: getRoutes,
    [UPDATE_SEARCH_MODE]: updateSearchMode,
    [SET_AI_FEEDBACK_MODAL_VISIBLE]: setAIFeedbackModalVisible,
    [SET_AI_FEEDBACK_FORM_FILLED]: setIsAIFeedbackFormFilled,
    [SUBMIT_AI_FEEDBACK]: submitAIFeedback,
    [SET_CONTACT_MODAL_VISIBLE]: (state: typeof initialState, { payload }) => ({
      ...state,
      isContactModalVisible: payload
    }),
    [SHOW_POLL_POPUP]: (state: typeof initialState, { payload }) => ({
      ...state,
      pollPopup: payload
    }),
    [HIDE_POLL_POPUP]: (state: typeof initialState) => ({
      ...state,
      pollPopup: null
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/containers/App/reducer.ts